/**
 * 店舗グループAPI
 * 店舗グループの情報を取得
 */

import { apiGet } from './client';
import type { SellerGroup } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { SellerGroup } from '@/lib/types';

/**
 * 店舗グループ一覧を取得
 */
export async function getSellerGroups(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<SellerGroup[]> {
  return apiGet<SellerGroup[]>(`/${accountCode}/seller-groups`, authHeaders);
}
